const base64ToFile = (base64String: string, filename: string): File | null => {
  const matches = base64String.match(/^data:(image\/\w+);base64,(.+)$/);
  if (!matches) return null;

  const mimeType = matches[1];
  const byteCharacters = atob(matches[2]);
  const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeType });

  return new File([blob], `${filename}.${mimeType.split("/")[1]}`, { type: mimeType });
};

export default base64ToFile;